import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNoDataFound = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={50} height={60} fill='currentColor' {...props}>
    <g clipPath='url(#no-data-found_svg__a)'>
      <path d='m45.625 51.655-.49-3.97-.72.09-.73.09.49 3.97c.11.88-.52 1.68-1.4 1.79l-34.2 4.2c-.88.11-1.68-.52-1.79-1.4l-5.26-42.88c-.03-.24.14-.46.38-.49l2.84-.32c.4-.04.69-.41.64-.81a.724.724 0 0 0-.81-.64l-2.84.32h-.02c-1.02.13-1.76 1.08-1.64 2.12l5.26 42.88a3.07 3.07 0 0 0 3.42 2.67l34.2-4.2a3.07 3.07 0 0 0 2.67-3.42' />
      <path d='m48.975 8.535-6.88-6.87c-.19-.19-.41-.34-.63-.48v6.97c0 .56.46 1.02 1.02 1.02h4.63c.4 0 .73.33.73.73s-.33.73-.73.73h-4.63a2.48 2.48 0 0 1-2.48-2.48V.725c-.07 0-.15-.02-.22-.02h-24.24c-1.81 0-3.27 1.46-3.27 3.27v41.05c0 1.81 1.46 3.27 3.27 3.27h31.13c1.81 0 3.27-1.46 3.27-3.27v-34.18c0-.87-.34-1.7-.96-2.31zm-28.32 10.71h13.3c.4 0 .73.33.73.73s-.33.73-.73.73h-13.3c-.4 0-.73-.33-.73-.73s.33-.73.73-.73m13.3 14.46h-13.3c-.4 0-.73-.33-.73-.73s.33-.73.73-.73h13.3c.4 0 .73.33.73.73s-.33.73-.73.73m8.7-6.29h-21.99c-.4 0-.73-.33-.73-.73s.33-.73.73-.73h21.99c.4 0 .73.33.73.73s-.33.73-.73.73' />
    </g>
    <defs>
      <clipPath id='no-data-found_svg__a'>
        <path d='M.065.705h49.87v58.59H.065z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNoDataFound;
